angular.element(document).ready(function (event) {

    var modules = [];
    
    modules.push('ngAnimate'); 
    modules.push('ngStorage'); 
    modules.push('ngSanitize'); 

    angular.module('uniavis', modules)
        .animation('.intro', intro)
        .component('archive', archive)
        .component('cookie', cookie)
        .component('eventArchive', eventArchive)
        .component('headerNav', headerNav)
        .component('newsletterForm', newsletterForm)
        .component('pageProgress', pageProgress)
        .component('searchForm', searchForm)
        .component('secret', secret)
        .component('sliderWrapper', sliderWrapper)
        .component('timeago', timeago)
        .component('timespan', timespan)
        .directive('anchorClick', anchorClick)
        .directive('championKerningFix', championKerningFix)
        .directive('detach', detach)
        .directive('facebookShare', facebookShare)
        .directive('factbox', factbox)
        .directive('fadein', fadein)
        .directive('freezeBody', freezeBody)
        .directive('momentize', momentize)
        .directive('twitterShare', twitterShare)
        .directive('videoResizer', videoResizer)
        .factory('DataService', DataService)
        .run(run);

    // Bootstrap manually
    angular.bootstrap(document.getElementById('ng-app'), ['uniavis']);
});